module.exports = __webpack_public_path__ + "img/apcs3.0fce1c68.jpeg";